module.exports = __webpack_public_path__ + "static/scrollsnap-296a61bc87d153446313a5e584fd4716.jpg";